import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { UserRole } from "../../../@types/userRole";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";
import { RootState } from "../../rootReducer";

export const removeFormFromUser = createAsyncThunk(
  "templateDetail/removeFormFromUser",
  async (userRole: UserRole, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const {
        data: [formSubmittedResponse],
      } = await axiosInstance.get(`${api.baseURL}formsubmitted`, {
        params: {
          where: {
            form: state.templateDetail.template.id,
            user: userRole.user.id,
          },
          limit: 1,
        },
      });

      if (!formSubmittedResponse) throw new Error("No fue encontrada la plantilla asignada.");

      const { data } = await axiosInstance.delete(
        `${api.baseURL}formsubmitted/${formSubmittedResponse.id}`
      );
      return userRole;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
